import { useCallback, useState, useMemo } from 'react';
import {
  CSMLTimeFrame,
  civilDateRangeEqual,
  civilDateRangeToDebugString,
  getDateAddedChoiceOptions,
  handleRealUsedFlag,
} from '@bingads-webui-campaign-react/asset-library-model';
import { getCivilDateToday } from '@bingads-webui-universal/temporal-utitlities';

const yesterday = getCivilDateToday().plus({ days: -1 });
const DEFAULT_RANGE = { start: yesterday, end: yesterday };

export const useDateAddedFilter = ({
  logger,
  i18n,
  ianaTimeZone,
  preference,
  realUsedFlagSuffix,
}) => {
  const [dateAddedFilter, setDateAddedFilter] = useState(CSMLTimeFrame.Anytime);
  // date range user selected for 'Custom'
  const [dateAddedFilterCustomDateRange, setDateAddedFilterCustomDateRange] = useState(DEFAULT_RANGE);

  const dateAddedChoiceOptions = useMemo(
    () => getDateAddedChoiceOptions(i18n, ianaTimeZone),
    [i18n, ianaTimeZone]
  );

  const onDateAddedFilterChange = useCallback(({ timeframe: tf, customDateRange: cdr }) => {
    if (tf !== dateAddedFilter) {
      logger.logTrace('onDateAddedFilterChange', { dateAddedFilter: tf });
      setDateAddedFilter(tf);
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
    if (!civilDateRangeEqual(cdr, dateAddedFilterCustomDateRange)) {
      logger.logTrace('onDateAddedFilterChange', { customDateRange: civilDateRangeToDebugString(cdr) });
      setDateAddedFilterCustomDateRange(cdr);
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
  }, [dateAddedFilter, dateAddedFilterCustomDateRange, logger, preference, realUsedFlagSuffix]);

  return {
    dateAddedChoiceOptions,
    dateAddedFilter,
    dateAddedFilterCustomDateRange,
    onDateAddedFilterChange,
  };
};
